import React from 'react'
import { all, takeEvery, put, call, select } from 'redux-saga/effects'
import { notification, Modal } from 'antd'
import actions from './actions'
import { SAVE_200_MSG, SAVE_200_DESC } from '../../constants'
import {
  find,
  save,
  createWorkOrderByProposal,
  createWorkorders,
  createWorkordersV2,
  get,
  create,
  recall,
  getWorkOrders2,
  getWorkOrdersForInvoice2,
  saveAsset,
  savePdf,
  nextControl,
  nextControlV2,
  getAppointmenDate,
  generalCostView,
  listByMainInventoryID,
  hardDelete,
} from '../../services/workOrder'

import {
  getAssetTecReport,
  getAssetTecCount,
  getPreventiveMaintenanceReport,
  getBillingTabulation,
} from '../../services/report'

function* fetchWorkOrderEdit({ id }) {
  try {
    console.log('fetchWorkOrderEdit', id)
    yield put({
      type: actions.REQUESTING,
    })
    const result = yield call(find, id)
    console.log('fetchWorkOrderEdit result', result)
    yield put({
      type: actions.EDIT_WORKORDER,
      result,
    })
  } catch (e) {
    console.error('fetchWorkOrderEdit error', e)
  }
}

function* fetchNextControls({ contractId, startDate, endDate }) {
  try {
    yield put({
      type: actions.REQUESTING,
    })
    const result = yield call(nextControl, contractId, startDate, endDate)
    yield put({
      type: actions.FETCH_NEXTCONTROLS_RECIEVED,
      result,
    })
  } catch (e) {
    console.error('fetchNextControls error', e)
  }
}

function* fetchNextControlsV2({ contractId, startDate, endDate, includeMissedPms }) {
  try {
    yield put({
      type: actions.REQUESTING,
    })
    const result = yield call(nextControlV2, contractId, startDate, endDate, includeMissedPms)
    yield put({
      type: actions.FETCH_NEXTCONTROLSV2_RECIEVED,
      result,
    })
  } catch (e) {
    console.error('fetchNextControlsV2 error', e)
  }
}

function* fetchWorkOrderSave(values) {
  try {
    yield put({
      type: actions.REQUESTING,
    })
    const serviceResponse = yield call(save, values)
    if (!serviceResponse) {
      // Backend rejected the save (e.g. a validation error, already shown as a
      // toast by the API layer). Keep the page alive with the current record.
      const currentEditing = yield select(state => state.workOrders.editing)
      yield put({
        type: actions.SAVE_WORKORDER_RECIEVED,
        result: currentEditing,
      })
      return
    }
    if (serviceResponse.status !== 0) {
      notification.success({ message: SAVE_200_MSG, description: SAVE_200_DESC })
    } else {
      Modal.error({
        title: 'Error',
        content: serviceResponse.message,
        onOk() {
          console.log('OK')
          window.location.reload()
        },
      })
    }
    const result = yield call(get, serviceResponse.value)
    yield put({
      type: actions.SAVE_WORKORDER_RECIEVED,
      result,
    })
  } catch (e) {
    console.error('fetchWorkOrderSave error', e)
    notification.error({ message: 'Save failed', description: e.message })
  }
}

function* fetchCreateWorkOrderByProposal({ proposalID, withDataFromProposal }) {
  console.log('fetchCreateWorkOrderByProposal', proposalID)

  yield put({
    type: actions.REQUESTING,
  })
  const result = yield call(createWorkOrderByProposal, proposalID, withDataFromProposal)
  console.log('fetchCreateWorkOrderByProposal result', result)
  if (result.status === 1) {
    notification.success({ message: SAVE_200_MSG, description: SAVE_200_DESC })
  } else {
    notification.error({ message: '', description: result.message })
  }
  yield put({
    type: actions.CREATE_WORKORDER_BY_PROPOSAL_RECIEVED,
    result,
  })
}

function* createAutoWorkorders({ values, contractId, startDate, endDate }) {
  yield put({
    type: actions.REQUESTING,
  })

  const result2 = yield call(createWorkorders, values, startDate, endDate)
  console.log(result2)
  if (result2.success === true) {
    notification.success({ message: SAVE_200_MSG, description: 'Work orders created.' })
  } else {
    let description = ''
    result2.errorItems.forEach(element => {
      element.errorMessages.forEach(element2 => {
        description += `${element2}\n\n`
      })
    })

    notification.error({
      message: SAVE_200_MSG,
      description: (
        <>
          {description.split('\n').map(error => {
            return (
              <>
                {error}
                <br />
              </>
            )
          })}
        </>
      ),
      duration: 0,
    })
  }

  yield put({
    type: actions.REQUESTING,
  })
  const result = yield call(nextControl, contractId, startDate, endDate)
  yield put({
    type: actions.FETCH_NEXTCONTROLS_RECIEVED,
    result,
  })
}

function* createAutoWorkordersV2({ values, contractId, startDate, endDate, includeMissedPms }) {
  yield put({
    type: actions.REQUESTING,
  })

  const result2 = yield call(createWorkordersV2, values, startDate, endDate, includeMissedPms)
  console.log(result2)
  if (result2.success === true) {
    notification.success({ message: SAVE_200_MSG, description: 'Work orders created.' })
  } else {
    let description = ''
    result2.errorItems.forEach(element => {
      element.errorMessages.forEach(element2 => {
        description += `${element2}\n\n`
      })
    })

    notification.error({
      message: SAVE_200_MSG,
      description: (
        <>
          {description.split('\n').map(error => {
            return (
              <>
                {error}
                <br />
              </>
            )
          })}
        </>
      ),
      duration: 0,
    })
  }

  yield put({
    type: actions.REQUESTING,
  })
  const result = yield call(nextControlV2, contractId, startDate, endDate, includeMissedPms)
  yield put({
    type: actions.FETCH_NEXTCONTROLSV2_RECIEVED,
    result,
  })
}

function* createNewWorkorder() {
  try {
    yield put({
      type: actions.REQUESTING,
    })
    const result = yield call(create)
    yield put({
      type: actions.CREATE_NEW_WORKORDER_RECIEVED,
      result,
    })
  } catch (e) {
    console.error('createNewWorkorder error', e)
  }
}

function* resetNewWorkorder() {
  yield put({
    type: actions.CREATE_NEW_WORKORDER_RESET_RECIEVED,
  })
}

function* assetHistory({ inventoryid }) {
  yield put({
    type: actions.REQUESTING,
  })
  const result = yield call(getAssetTecReport, inventoryid)
  yield put({
    type: actions.FETCH_WORKORDER_ASSET_REPORT_RECIEVED,
    result,
  })
}

function* assetHistoryReset() {
  yield put({
    type: actions.FETCH_WORKORDER_ASSET_REPORT_RESET_RECIEVED,
  })
}

function* assetHistoryCount({ inventoryid, workOrderID }) {
  yield put({
    type: actions.REQUESTING,
  })
  const result = yield call(getAssetTecCount, inventoryid, workOrderID)
  yield put({
    type: actions.FETCH_WORKORDER_ASSET_COUNT_RECIEVED,
    result,
  })
}

function* recallWorkorder({ workOrderID, orderNumber }) {
  yield put({
    type: actions.REQUESTING,
  })
  const result = yield call(recall, workOrderID, orderNumber)
  yield put({
    type: actions.RECALL_WORKORDER_RECIEVED,
    result,
  })
}

function* fetchWorkOrderFilter({
  size,
  index,
  searchTerm,
  orderBy,
  completedDate,
  orderNumber,
  workOrderStatus,
  mainInventoryNumber,
  inventoryNumber,
  workOrderType,
  areaID,
  locationID,
  address,
  callerName,
  trackingNumber,
  partNumbers,
  technicianNames,
  barcode,
  priority,
  isTechnicianNoteExist,
  proposalBudgetStatus,
  inventoryClassID,
}) {
  size = size || localStorage.getItem('pageSize') || 15

  const savedFilters = localStorage.getItem('workOrderFilters')

  if (savedFilters) {
    const parsedFilters = JSON.parse(savedFilters)

    completedDate = completedDate || parsedFilters.completedDate || null
    orderNumber = orderNumber || parsedFilters.orderNumber || null
    workOrderStatus = workOrderStatus || parsedFilters.workOrderStatus || null
    mainInventoryNumber = mainInventoryNumber || parsedFilters.mainInventoryNumber || null
    inventoryNumber = inventoryNumber || parsedFilters.inventoryNumber || null
    workOrderType = (workOrderType !== undefined && workOrderType !== null && workOrderType !== '') ? workOrderType : (parsedFilters.workOrderType || null)
    areaID = areaID || parsedFilters.areaID || null
    locationID = locationID || parsedFilters.locationID || null
    address = address || parsedFilters.address || null
    callerName = callerName || parsedFilters.callerName || null
    trackingNumber = trackingNumber || parsedFilters.trackingNumber || null
    partNumbers = partNumbers || parsedFilters.partNumbers || null
    technicianNames = technicianNames || parsedFilters.technicianNames || null
    barcode = barcode || parsedFilters.barcode || null
    priority = priority || parsedFilters.priority || null
    isTechnicianNoteExist = isTechnicianNoteExist || parsedFilters.isTechnicianNoteExist || null
    proposalBudgetStatus = proposalBudgetStatus || parsedFilters.proposalBudgetStatus || null
    inventoryClassID = inventoryClassID || parsedFilters.inventoryClassID || null
  }

  try {
    yield put({
      type: actions.REQUESTING,
    })
    const result = yield call(
      getWorkOrders2,
      size,
      index,
      searchTerm,
      orderBy,
      completedDate,
      orderNumber,
      workOrderStatus,
      mainInventoryNumber,
      inventoryNumber,
      workOrderType,
      areaID,
      locationID,
      address,
      callerName,
      trackingNumber,
      partNumbers,
      technicianNames,
      barcode,
      priority,
      isTechnicianNoteExist,
      proposalBudgetStatus,
      inventoryClassID,
    )
    yield put({
      type: actions.LIST_WORKORDER,
      result,
    })
  } catch (e) {
    console.error('fetchWorkOrderFilter error', e)
  }
}

function* fetchWorkOrderFilterForInvoice2({
  size,
  index,
  searchTerm,
  orderBy,
  startDate,
  endDate,
  workOrderType,
  inventoryClassID,
}) {
  size = size || localStorage.getItem('pageSize') || 150

  const savedFilters = localStorage.getItem('invoiceCompletedWorkOrderFilters')

  if (savedFilters) {
    const parsedFilters = JSON.parse(savedFilters)

    startDate = startDate || parsedFilters.startDate || null
    endDate = endDate || parsedFilters.endDate || null
    workOrderType = workOrderType || parsedFilters.workOrderType || null
    inventoryClassID = inventoryClassID || parsedFilters.inventoryClassID || null
  }

  yield put({
    type: actions.REQUESTING,
  })
  const result = yield call(
    getWorkOrdersForInvoice2,
    size,
    index,
    searchTerm,
    orderBy,
    startDate,
    endDate,
    workOrderType,
    inventoryClassID,
    null,
    2,
  )
  yield put({
    type: actions.LIST_WORKORDER_FOR_INVOICE2,
    result,
  })
}

function* SaveAsset(values) {
  yield put({
    type: actions.REQUESTING,
  })
  yield call(saveAsset, values)
  const result = yield call(find, values.values.workOrderID)
  yield put({
    type: actions.EDIT_WORKORDER,
    result,
  })
}

function* SavePdf({ workOrderID, file }) {
  yield put({
    type: actions.REQUESTING,
  })
  const result = yield call(savePdf, workOrderID, file)
  yield put({
    type: actions.SAVEPDF_RECIEVED,
    result,
  })
}

function* fetchCostViews({ id }) {
  yield put({
    type: actions.REQUESTING,
  })
  const result = yield call(generalCostView, id)
  yield put({
    type: actions.FETCH_WORKORDER_COSTVIEW_RECIEVED,
    result,
  })
}

function* printPopup() {
  yield put({
    type: actions.PRINT_POPUP_RECIEVED,
  })
}

function* printPopupReset() {
  yield put({
    type: actions.PRINT_POPUP_RESET_RECIEVED,
  })
}

function* budgetPopup() {
  yield put({
    type: actions.POPUP_BUDGET_RECIEVED,
  })
}

function* budgetPopupReset() {
  yield put({
    type: actions.POPUP_BUDGET_RESET_RECIEVED,
  })
}

function* openPopupCustomerSignature() {
  yield put({
    type: actions.OPEN_POPUP_CUSTOMER_SIGNATURE_RECIEVED,
  })
}

function* closePopupCustomerSignature() {
  yield put({
    type: actions.CLOSE_POPUP_CUSTOMER_SIGNATURE_RECIEVED,
  })
}

function* openPopupTechnicianWork() {
  yield put({
    type: actions.OPEN_POPUP_TECHNICIAN_WORK_RECIEVED,
  })
}

function* closePopupTechnicianWork() {
  yield put({
    type: actions.CLOSE_POPUP_TECHNICIAN_WORK_RECIEVED,
  })
}

function* openPopupServiceOrderFile() {
  yield put({
    type: actions.OPEN_POPUP_SERVICE_ORDER_FILE_RECIEVED,
  })
}

function* closePopupServiceOrderFile() {
  yield put({
    type: actions.CLOSE_POPUP_SERVICE_ORDER_FILE_RECIEVED,
  })
}

function* openPopupWorkOrderCostSummary() {
  yield put({
    type: actions.OPEN_POPUP_WORKORDER_COST_SUMMARY_RECIEVED,
  })
}

function* closePopupWorkOrderCostSummary() {
  yield put({
    type: actions.CLOSE_POPUP_WORKORDER_COST_SUMMARY_RECIEVED,
  })
}

function* openPopupWorkOrderProposalInfo() {
  yield put({
    type: actions.OPEN_POPUP_WORKORDER_PROPOSAL_INFO_RECIEVED,
  })
}

function* closePopupWorkOrderProposalInfo() {
  yield put({
    type: actions.CLOSE_POPUP_WORKORDER_PROPOSAL_INFO_RECIEVED,
  })
}

function* openPopupWorkOrderEmailSend() {
  yield put({
    type: actions.OPEN_POPUP_WORKORDER_EMAIL_SEND_RECIEVED,
  })
}

function* closePopupWorkOrderEmailSend() {
  yield put({
    type: actions.CLOSE_POPUP_WORKORDER_EMAIL_SEND_RECIEVED,
  })
}

function* openPopupWorkOrderAttachment() {
  yield put({
    type: actions.OPEN_POPUP_WORKORDER_ATTACHMENT_RECIEVED,
  })
}

function* closePopupWorkOrderAttachment() {
  yield put({
    type: actions.CLOSE_POPUP_WORKORDER_ATTACHMENT_RECIEVED,
  })
}

function* openPopupWorkOrderListByMainInventory() {
  yield put({
    type: actions.OPEN_POPUP_WORKORDERLISTBYMAININVENTORY_RECIEVED,
  })
}

function* closePopupWorkOrderListByMainInventory() {
  yield put({
    type: actions.CLOSE_POPUP_WORKORDERLISTBYMAININVENTORY_RECIEVED,
  })
}

function* fetchAppointmenDate({ id }) {
  yield put({
    type: actions.REQUESTING,
  })
  const result = yield call(getAppointmenDate, id)
  yield put({
    type: actions.GET_APPOINTMENT_DATE_RECIEVED,
    payload: result,
  })
}
function* resetAppointmenDate() {
  yield put({
    type: actions.GET_APPOINTMENT_DATE_RESET_RECIEVED,
  })
}

function* fetchGeneralCostView({ id }) {
  if (id > 0) {
    yield put({
      type: actions.REQUESTING,
    })
    const result = yield call(generalCostView, id)
    yield put({
      type: actions.GET_COSTVIEW_RECIVEVED2,
      payload: result,
    })
  }
}

function* addInventoryCatch({ id }) {
  console.log('asda', id)
  yield put({
    type: actions.ADD_INVENTORY_RECIEVED,
    payload: id,
  })
}

function* addInventoryCatchReset() {
  yield put({
    type: actions.ADD_INVENTORY_RESET_RECIEVED,
  })
}

function* fetchWorkOrderListByMainInventory({ id }) {
  if (id > 0) {
    yield put({
      type: actions.REQUESTING,
    })
    const result = yield call(listByMainInventoryID, id)
    yield put({
      type: actions.GET_WORKORDERLISTBYMAININVENTORY_RECIEVED,
      payload: result,
    })
  }
}

function* preventiveMaintenanceReport({ startDate, endDate }) {
  yield put({
    type: actions.REQUESTING,
  })
  const result = yield call(getPreventiveMaintenanceReport, startDate, endDate)
  console.log('preventiveMaintenanceReport', result.value)
  yield put({
    type: actions.FETCH_PREVENTIVE_MAINTENANCE_REPORT_RECIEVED,
    payload: result,
  })
}

function* billingTabulation({ startDate, endDate }) {
  yield put({
    type: actions.REQUESTING,
  })
  const result = yield call(getBillingTabulation, startDate, endDate)
  console.log('getBillingTabulation', result.value)
  yield put({
    type: actions.FETCH_BILLING_TABULATION_RECIEVED,
    payload: result,
  })
}

function* openPopupWorkOrderProtocolHistory() {
  yield put({
    type: actions.OPEN_POPUP_WORKORDER_PROTOCOL_HISTORY_RECEIVED,
  })
}

function* closePopupWorkOrderProtocolHistory() {
  yield put({
    type: actions.CLOSE_POPUP_WORKORDER_PROTOCOL_HISTORY_RECEIVED,
  })
}

function* openPopupWorkOrderProtocol8Form({ protocolAssignment }) {
  console.log('openPopupWorkOrderProtocol8Form saga', protocolAssignment)
  yield put({
    type: actions.OPEN_POPUP_WORKORDER_PROTOCOL8_FORM_RECEIVED,
    payload: protocolAssignment,
  })
}

function* closePopupWorkOrderProtocol8Form() {
  yield put({
    type: actions.CLOSE_POPUP_WORKORDER_PROTOCOL8_FORM_RECEIVED,
  })
}

function* openPopupWorkOrderProtocol10Form({ protocolAssignment }) {
  console.log('openPopupWorkOrderProtocol10Form saga', protocolAssignment)
  yield put({
    type: actions.OPEN_POPUP_WORKORDER_PROTOCOL10_FORM_RECEIVED,
    payload: protocolAssignment,
  })
}

function* closePopupWorkOrderProtocol10Form() {
  yield put({
    type: actions.CLOSE_POPUP_WORKORDER_PROTOCOL10_FORM_RECEIVED,
  })
}

function* openPopupWorkOrderProtocol11Form({ protocolAssignment }) {
  console.log('openPopupWorkOrderProtocol11Form saga', protocolAssignment)
  yield put({
    type: actions.OPEN_POPUP_WORKORDER_PROTOCOL11_FORM_RECEIVED,
    payload: protocolAssignment,
  })
}

function* closePopupWorkOrderProtocol11Form() {
  yield put({
    type: actions.CLOSE_POPUP_WORKORDER_PROTOCOL11_FORM_RECEIVED,
  })
}

function* fetchHardDeleteWorkOrder({ workOrderID }) {
  try {
    const result = yield call(hardDelete, workOrderID)
    if (result && result.status === 1) {
      notification.success({ message: 'Work order deleted successfully.' })
      // Redirect to work order list
      window.location.href = '/workorders'
    } else {
      notification.error({ message: 'Delete failed', description: result?.message || 'Unknown error' })
    }
  } catch (e) {
    notification.error({ message: 'Delete failed', description: e.message })
  }
}

export default function* rootSaga() {
  yield all([
    takeEvery(actions.GET_APPOINTMENT_DATE, fetchAppointmenDate),
    takeEvery(actions.GET_APPOINTMENT_DATE_RESET, resetAppointmenDate),

    // This two lines actually do the same thing but the first one is more readable and the second one older than the first one.
    // we have to change all usage in the project to the first one.
    takeEvery(actions.GET_COSTVIEW2, fetchGeneralCostView),
    takeEvery(actions.FETCH_WORKORDER_COSTVIEW, fetchCostViews),

    takeEvery(actions.PRINT_POPUP, printPopup),
    takeEvery(actions.PRINT_POPUP_RESET, printPopupReset),

    takeEvery(actions.POPUP_BUDGET, budgetPopup),
    takeEvery(actions.POPUP_BUDGET_RESET, budgetPopupReset),

    takeEvery(actions.OPEN_POPUP_CUSTOMER_SIGNATURE, openPopupCustomerSignature),
    takeEvery(actions.CLOSE_POPUP_CUSTOMER_SIGNATURE, closePopupCustomerSignature),

    takeEvery(actions.OPEN_POPUP_TECHNICIAN_WORK, openPopupTechnicianWork),
    takeEvery(actions.CLOSE_POPUP_TECHNICIAN_WORK, closePopupTechnicianWork),

    takeEvery(actions.OPEN_POPUP_SERVICE_ORDER_FILE, openPopupServiceOrderFile),
    takeEvery(actions.CLOSE_POPUP_SERVICE_ORDER_FILE, closePopupServiceOrderFile),

    takeEvery(actions.OPEN_POPUP_WORKORDER_COST_SUMMARY, openPopupWorkOrderCostSummary),
    takeEvery(actions.CLOSE_POPUP_WORKORDER_COST_SUMMARY, closePopupWorkOrderCostSummary),

    takeEvery(actions.OPEN_POPUP_WORKORDER_PROPOSAL_INFO, openPopupWorkOrderProposalInfo),
    takeEvery(actions.CLOSE_POPUP_WORKORDER_PROPOSAL_INFO, closePopupWorkOrderProposalInfo),

    takeEvery(actions.OPEN_POPUP_WORKORDER_EMAIL_SEND, openPopupWorkOrderEmailSend),
    takeEvery(actions.CLOSE_POPUP_WORKORDER_EMAIL_SEND, closePopupWorkOrderEmailSend),

    takeEvery(actions.OPEN_POPUP_WORKORDER_ATTACHMENT, openPopupWorkOrderAttachment),
    takeEvery(actions.CLOSE_POPUP_WORKORDER_ATTACHMENT, closePopupWorkOrderAttachment),

    takeEvery(actions.GET_WORKORDERLISTBYMAININVENTORY, fetchWorkOrderListByMainInventory),
    takeEvery(
      actions.OPEN_POPUP_WORKORDERLISTBYMAININVENTORY,
      openPopupWorkOrderListByMainInventory,
    ),
    takeEvery(
      actions.CLOSE_POPUP_WORKORDERLISTBYMAININVENTORY,
      closePopupWorkOrderListByMainInventory,
    ),

    takeEvery(actions.OPEN_POPUP_WORKORDER_PROTOCOL_HISTORY, openPopupWorkOrderProtocolHistory),
    takeEvery(actions.CLOSE_POPUP_WORKORDER_PROTOCOL_HISTORY, closePopupWorkOrderProtocolHistory),

    takeEvery(actions.OPEN_POPUP_WORKORDER_PROTOCOL8_FORM, openPopupWorkOrderProtocol8Form),
    takeEvery(actions.CLOSE_POPUP_WORKORDER_PROTOCOL8_FORM, closePopupWorkOrderProtocol8Form),

    takeEvery(actions.OPEN_POPUP_WORKORDER_PROTOCOL10_FORM, openPopupWorkOrderProtocol10Form),
    takeEvery(actions.CLOSE_POPUP_WORKORDER_PROTOCOL10_FORM, closePopupWorkOrderProtocol10Form),

    takeEvery(actions.OPEN_POPUP_WORKORDER_PROTOCOL11_FORM, openPopupWorkOrderProtocol11Form),
    takeEvery(actions.CLOSE_POPUP_WORKORDER_PROTOCOL11_FORM, closePopupWorkOrderProtocol11Form),

    takeEvery(actions.FETCH_WORKORDER, fetchWorkOrderEdit),
    takeEvery(actions.SAVE_WORKORDER, fetchWorkOrderSave),
    takeEvery(actions.CREATE_WORKORDER_BY_PROPOSAL, fetchCreateWorkOrderByProposal),
    takeEvery(actions.CREATE_AUTO_WORKORDERS, createAutoWorkorders),
    takeEvery(actions.CREATE_AUTO_WORKORDERSV2, createAutoWorkordersV2),
    takeEvery(actions.CREATE_NEW_WORKORDER, createNewWorkorder),
    takeEvery(actions.CREATE_NEW_WORKORDER_RESET, resetNewWorkorder),
    takeEvery(actions.FETCH_WORKORDER_ASSET_REPORT, assetHistory),
    takeEvery(actions.FETCH_WORKORDER_ASSET_REPORT_RESET, assetHistoryReset),
    takeEvery(actions.FETCH_WORKORDER_ASSET_COUNT, assetHistoryCount),
    takeEvery(actions.RECALL_WORKORDER, recallWorkorder),
    takeEvery(actions.FETCH_WORKORDERS_FILTER, fetchWorkOrderFilter),
    takeEvery(actions.FETCH_WORKORDERS_FILTER_FOR_INVOICE2, fetchWorkOrderFilterForInvoice2),

    takeEvery(actions.SAVE_ASSET, SaveAsset),
    takeEvery(actions.SAVEPDF, SavePdf),
    takeEvery(actions.FETCH_NEXTCONTROLS, fetchNextControls),
    takeEvery(actions.FETCH_NEXTCONTROLSV2, fetchNextControlsV2),

    takeEvery(actions.ADD_INVENTORY, addInventoryCatch),
    takeEvery(actions.ADD_INVENTORY_RESET, addInventoryCatchReset),
    takeEvery(actions.FETCH_PREVENTIVE_MAINTENANCE_REPORT, preventiveMaintenanceReport),
    takeEvery(actions.FETCH_BILLING_TABULATION, billingTabulation),
    takeEvery(actions.DELETE_WORKORDER, fetchHardDeleteWorkOrder),
  ])
}
